import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { getRuleConfig } from 'helpers/rulesHelper';
import { Item, Row } from 'components/ui/table/elements';
import ArrayConfiguration from 'pages/products/configuration/ArrayConfiguration';
import styled from 'styled-components';
import TextInputTableCell from 'pages/products/configuration/TextInputTableCell';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const StyledInputWrapper = styled.div`
    &>div:not(:first-of-type) {
        margin-top: 10px;
    }
`;

const INPUT_TYPE = 'email_domain';
const VALUE_PROPERTY = 'value';

class EmailDomainRule extends Component {
    config = null;

    state = {
        prepared: false,
    };

    componentDidMount() {
        this.config = getRuleConfig(utils.firstCharToLowerCase(this.props.type)).config;

        this.reinitialize();
    }

    generateValues = (values) => {
        if (utils.isEmpty(values)) {
            return null;
        }

        const generated = utils.map(values, (value) => {
            return {
                id: Math.floor(Math.random() * Date.now()),
                [INPUT_TYPE]: value,
            };
        });

        return generated;
    }

    reinitialize = () => {
        const {
            initialize,
            value,
        } = this.props;

        this.setState({
            prepared: false,
        });

        const initialState = {};

        initialState[VALUE_PROPERTY] = this.generateValues(value[VALUE_PROPERTY]);

        initialize(initialState);

        this.setState({
            prepared: true,
        });
    }

    updateFormState = (values) => {
        const {
            formValues: stateValues,
            onUpdate,
        } = this.props;

        const formValues = { ...stateValues };

        if (values) {
            formValues[VALUE_PROPERTY] = values.map((valueObject) => {
                return valueObject[INPUT_TYPE];
            });
        } else {
            formValues[VALUE_PROPERTY] = values;
        }

        return onUpdate(formValues);
    }

    onAddValue = (name) => {
        const {
            change,
            formValues: {
                value,
            },
            untouch,
        } = this.props;

        const values = [];

        if (!utils.isEmpty(value)) {
            values.push(...value);
        }

        values.push({
            id: Math.floor(Math.random() * Date.now()),
            [INPUT_TYPE]: '',
        });

        change(name, values);
        untouch(name);
    }

    onChangeValue = (event, eventValue, values) => {
        event.preventDefault();

        const {
            change,
            touch,
        } = this.props;

        const { id } = event.target;

        if (eventValue.length > 0 && eventValue.length < 3) {
            return;
        }

        const newValues = utils.map(values, (valueObject) => {
            if (valueObject.id == id) {
                valueObject[INPUT_TYPE] = eventValue;
            }

            return valueObject;
        });

        change(VALUE_PROPERTY, newValues);
        touch(VALUE_PROPERTY);

        this.updateFormState(newValues);
    }

    onDeleteValue = (id) => {
        const { change, formValues } = this.props;
        const { value: stateValue } = formValues;

        let newValues = [
            ...stateValue,
        ];

        if (newValues.length > 1) {
            newValues = newValues.filter((value) => {
                return value.id !== id;
            });
        } else {
            newValues = null;
        }

        change(VALUE_PROPERTY, newValues);

        this.updateFormState(newValues);
    }

    render() {
        const {
            form,
            translate,
            type,
        } = this.props;

        const { prepared } = this.state;

        if (!this.config || !prepared) {
            return null;
        }

        return (
            <StyledInputWrapper>
                <Row>
                    <Item>
                        <Field
                            key={ `${ form }-input-${ VALUE_PROPERTY }` }
                            component={ ArrayConfiguration }
                            fields={ [
                                INPUT_TYPE,
                            ] }
                            inputComponent={ TextInputTableCell }
                            id={ type }
                            name={ VALUE_PROPERTY }
                            onAdd={ this.onAddValue }
                            onChange={ this.onChangeValue }
                            onDelete={ this.onDeleteValue }
                            placeholder={ translate(`resources.discounts.placeholders.${ INPUT_TYPE }`) }
                            type={ INPUT_TYPE }
                            title={ translate(`resources.products.${ VALUE_PROPERTY }.title`) }
                        />
                    </Item>
                </Row>
            </StyledInputWrapper>
        );
    }
}

EmailDomainRule.propTypes = {
    change: PropTypes.func.isRequired,
    form: PropTypes.string.isRequired,
    formValues: PropTypes.shape({
        value: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                [INPUT_TYPE]: PropTypes.string,
            }),
        ),
    }),
    initialize: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    touch: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    untouch: PropTypes.func.isRequired,
    value: PropTypes.shape({
        value: PropTypes.arrayOf(PropTypes.string),
    }),
};

const mapStateToProps = (state, props) => {
    const {
        id,
        type,
    } = props;

    const form = `${ type }-${ id }`;

    return {
        form: form,
        formValues: getFormValues(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps, null),
    reduxForm(),
);

export default enhance(EmailDomainRule);


// WEBPACK FOOTER //
// ./src/pages/discounts/rules/types/EmailDomainRule.js